import { IListParams } from 'models/settingsV2.model';
import { ACTION_IDS, ACTION_NAME, PAGE_NAMES, RESOURCES, SETTINGS_V2_ACTION } from '../../../../../settingsV2Constant';

export const makeActionList = (params: IListParams) => {
	const { hasPermission } = params;
	return {
		bulkActions: [
			{
				name: ACTION_NAME.BULK_PERMISSIONS,
				id: ACTION_IDS.BULK_ACTIONS,
				isEnabled: () => {
					return hasPermission({
						configPageName: PAGE_NAMES.permissionsManagement,
						configResourceName: RESOURCES.bulkPermission,
						configActionName: SETTINGS_V2_ACTION.bulkActions
					});
				}
			}
		]
	};
};

export default {
	makeActionList
};
